export default "__VITE_ASSET__08b1baa3__"